import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class EmbedPaymentDemoMarketingAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = "General";
  controllerName = "embedpaymentmonitoractions";

  /**
   * Lấy danh sách hành động người dùng trên marketing
   */
  getList(payload) {
    var param = {
      SkipCount: payload.skip || 0,
      MaxResultCount: payload.take || 20,
    };

    let request = {
      url: window._apis.BaseUrlGeneral + "/embedpaymentmonitoractions/list",
      data: param,
    };
    return httpClient.postAsync(request);
  }
}

export default new EmbedPaymentDemoMarketingAPI();
